import * as React from "react";
import { ChoiceList } from "@cmsgov/design-system-core";
import { StoreState } from "./../../common/types";
import { addCheckedToSelectedOption } from "./../../common/services/Filters";

export interface Props {
  selectedAggReport: StoreState.Query["aggReport"];
  onChange: (changed: string) => void;
}

function SelectAggReport({ selectedAggReport, onChange }: Props) {
  const choiceChanged = (event: any) => {
    onChange(event.target.value);
  };
  let choices = [
    { value: "detail", label: "Detail" },
    { value: "by_state", label: "By State" },
    { value: "by_year", label: "By Year" },
  ];
  choices = addCheckedToSelectedOption(choices, selectedAggReport);
  return (
    <ChoiceList
      choices={choices}
      label="Type of Report"
      name="chooseAggReport"
      type="select"
      onChange={choiceChanged}
    />
  );
}

export default SelectAggReport;
